
import { computed, defineComponent, ref } from 'vue';
import { UiInput } from '@/ui-kit';
import { usePhoneNumbers } from '../composition';

export default defineComponent({
	name: 'phone-number-select',
	components: {
		UiInput
	},
	emits: ['update:modelValue'],
	props: {
		label: { type: String, required: true },
		inputName: { type: String, required: true },
		modelValue: { required: true },
		loading: { type: Boolean, default: false }
	},
	setup(props, { emit }) {
		const { selectedPhoneNumber, phoneNumbers } =
			usePhoneNumbers();
		const focused = ref(false);

		const filteredPhoneNumbers = computed(() => {
			return phoneNumbers.value.filter(
				(number) =>
					number.phoneNumber.trim() !==
						(props.modelValue as any)?.replace(
							/[ -]/g,
							''
						) &&
					number.id !==
						selectedPhoneNumber.value?.id
			);
		});

		const onNumberClick = (number: string) => {
			if (!focused.value) {
				return;
			}
			emit('update:modelValue', number);
		};

		const onBlur = async () => {
			setTimeout(() => {
				focused.value = false;
			});
		};

		return {
			onNumberClick,
			onBlur,
			filteredPhoneNumbers,
			focused
		};
	}
});
